import axios from "axios";

const API_BASE = process.env.REACT_APP_API_URL;

const whatsappAPI = axios.create({
  baseURL: `${API_BASE}/api/whatsapp`,
  headers: {
    "Content-Type": "application/json",
  },
});

// Accept token as 1st arg to set Auth header dynamically
export const sendMessage = async (authToken, data) => {
  return whatsappAPI.post("/send-message", data, {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
};

export const sendBulkMessage = async (authToken, data) => {
  return whatsappAPI.post("/send-bulk-message", data, {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
};

export const sendMedia = async (authToken, data) => {
  return whatsappAPI.post("/send-media", data, {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
};

export const getGroupDetails = async (authToken, data) => {
  return whatsappAPI.post("/get-group-details", data, {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
};

export const getGroups = async (authToken, data) => {
  return whatsappAPI.post("/get-groups", data, {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
};

export const getGroupMessages = async (authToken, data) => {
  return whatsappAPI.post("/get-chats-of-groups", data, {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
};
